import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useNavigate } from 'react-router-dom';

const ExpenseAdvanceList = () => {
  const [expenseData, setExpenseData] = useState([]);  
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(updateNavbarHeading("Expense Advance"));
  }, []);

  const columns = {
    TXNName: { text: "Receipt No.", visible: true },
    Project: { text: "Project", visible: true },
    Employee: { text: "Employee", visible: true },
    TXNDate: { text: "Date", align: "center", visible: true },
    AdvanceAmount: { text: "Advance Amt.", align: "end", visible: true },
    CashAmount: { text: "Cash Amt.", align: "end", visible: true },
    CardAmount: { text: "Card Amt.", align: "end", visible: true },
    ExchangeRate:{ text: "Exchange Rate", align: "end", visible: true },
    StatusName:{ text: "Status", align: "center", visible: true },
  };

  const fetchExpenseAdvance = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/advance`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const ExpenseData = response?.data?.data;
        setExpenseData(ExpenseData);        
      } else {
        console.error(
          "Failed to fetch Expense Advance. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Expense Advance", error);
    }
  };

  useEffect(() => {
    fetchExpenseAdvance();
  }, []);

  const handleAdd = () => {
    navigate(`/expense-advance/add`)
  }

  const handleEdit = (id) => {
    navigate(`/expense-advance/edit/${id.ID}`)
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={expenseData}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              showIcon2={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              searchTerm={searchTerm}
              isActionRequired={true}
              setSearchTerm={setSearchTerm}
              isAddNewBtnRequired={true}
              handleAddNew={handleAdd}
              handleIcon2={handleEdit}
              icons={{
                Icon2: <i className="bi bi-pencil-square"></i>,
                Icon2Text: "Edit",
                Icon2Flag:"canEdit"
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpenseAdvanceList;
